import React from "react";
import cx from "classnames";

import { string, bool, func, object } from "prop-types";

const propTypes = {
  openText: string,
  closeText: string,
  classNames: string,
  isOpen: bool,
  controlID: string,
  onClick: func,
  onFocus: func,
  reversed: bool,
  buttonRef: object,
  showVisibleLabel: bool,
};

const MenuButton = (props) => {
  const {
    openText,
    closeText,
    classNames,
    controlID,
    reversed,
    buttonRef,
    isOpen,
    showVisibleLabel = false,
  } = props;

  const handleClick = (e) => {
    if (props.onClick) {
      props.onClick(e);
    }
  };

  let ariaLabel;
  if (!showVisibleLabel) {
    ariaLabel = isOpen ? closeText || "Close Menu" : openText || "Open Menu";
  }

  return (
    <button
      type="button"
      className={cx("btn menu-button", classNames, {
        "menu-button--right": reversed,
        "menu-button--labelled": showVisibleLabel && openText && closeText,
      })}
      aria-expanded={isOpen ? "true" : "false"}
      onClick={handleClick}
      onFocus={props.onFocus}
      aria-haspopup={true}
      aria-controls={controlID}
      aria-label={ariaLabel}
      ref={buttonRef}
      data-gtm-element="global nav mobile menu toggle"
    >
      <span>
        {showVisibleLabel && openText && closeText && (
          <>
            <span className="menu-button__open-text">{openText}</span>
            <span className="menu-button__close-text">{closeText}</span>
          </>
        )}
      </span>
    </button>
  );
};

MenuButton.propTypes = propTypes;
export default MenuButton;
